function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "pause-b",
  width: 48,
  height: 48,
  y: .27
}), React.createElement("filter", {
  id: "pause-a",
  width: "141.7%",
  height: "141.7%",
  x: "-20.8%",
  y: "-16.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "shadowInner"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowInner",
  result: "shadowInner"
}), React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.0352941176   0 0 0 0 0.0588235294   0 0 0 0 0.0980392157  0 0 0 0.4 0"
})), React.createElement("path", {
  id: "pause-d",
  d: "M18,16.5 L18,31.5393258"
}), React.createElement("filter", {
  id: "pause-c",
  width: "1300%",
  height: "256.5%",
  x: "-600%",
  y: "-65.6%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 3,
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 3,
  result: "shadowInner"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowInner",
  result: "shadowInner"
}), React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.0352941176   0 0 0 0 0.0588235294   0 0 0 0 0.0980392157  0 0 0 0.4 0"
})), React.createElement("path", {
  id: "pause-f",
  d: "M29,16.5 L29,31.5393258"
}), React.createElement("filter", {
  id: "pause-e",
  width: "1300%",
  height: "256.5%",
  x: "-600%",
  y: "-65.6%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 3,
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 3,
  result: "shadowInner"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowInner",
  result: "shadowInner"
}), React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.0352941176   0 0 0 0 0.0588235294   0 0 0 0 0.0980392157  0 0 0 0.4 0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#pause-a)",
  xlinkHref: "#pause-b"
}), React.createElement("rect", {
  width: 44,
  height: 44,
  x: 2,
  y: 2.27,
  stroke: "#FFF",
  strokeLinejoin: "square",
  strokeWidth: 4
}), React.createElement("g", {
  strokeLinecap: "square"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#pause-c)",
  xlinkHref: "#pause-d"
}), React.createElement("use", {
  stroke: "#FFF",
  strokeWidth: 6,
  xlinkHref: "#pause-d"
})), React.createElement("g", {
  strokeLinecap: "square"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#pause-e)",
  xlinkHref: "#pause-f"
}), React.createElement("use", {
  stroke: "#FFF",
  strokeWidth: 6,
  xlinkHref: "#pause-f"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/pause.3f453594.svg";
export { SvgComponent as ReactComponent };